module.exports = __webpack_public_path__ + "img/1.45ba4fca.webp";